module.exports = __webpack_public_path__ + "img/changzhou_s.558ff28.png";